import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ReportAdverseEventsPage } from './report-adverse-events';
import { MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule } from '@angular/material';

@NgModule({
  declarations: [
    ReportAdverseEventsPage,
  ],
  imports: [
    IonicPageModule.forChild(ReportAdverseEventsPage),
    MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule
  ],
})
export class ReportAdverseEventsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/report-adverse-events/report-adverse-events.module.ts